import React from "react";
import Footer from "./footer";

const ContactUs = () => {
  return (
    <React.Fragment>
      <div className="card rounded-3 shadow mx-lg-5 mx-md-3 mx-sm-1 my-4 p-xxl-5 py-3 text-center flex-fill">
        <h2>CONTACT US</h2>
        <div className="container w-75">
          <p>
            If you have any questions or inquiries, please do not hesitate to
            contact us
          </p>
          <form>
            <div>
              <label htmlFor="name" className="form-label"></label>
              <input
                type="text"
                className="form-control"
                id="name"
                placeholder="Enter your Name"
              />
            </div>

            <div>
              <label htmlFor="email" className="form-label"></label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter your Email"
              />
            </div>

            <div>
              <label htmlFor="messageType" className="form-label"></label>
              <select className="form-select" id="messageType">
                <option selected>Select your message type</option>
                <option value="1">Type1</option>
                <option value="2">Type2</option>
                <option value="3">Type3</option>
              </select>
            </div>

            <div>
              <label htmlFor="messageTitle" className="form-label"></label>
              <input
                type="text"
                className="form-control"
                id="messageTitle"
                placeholder="Message Title"
              />
            </div>

            <div>
              <label htmlFor="message" className="form-label"></label>
              <textarea
                className="form-control"
                id="message"
                placeholder="Write your message ..."
                rows="3"
              />
            </div>
          </form>
          <div className="my-5 d-flex text-white">
            <div
              className="p-1 d-flex align-items-center justify-content-center rounded-circle ms-auto me-3"
              style={{ width: 75, height: 75, backgroundColor: "#29a71a" }}
            >
              <a href="#" className="text-white">
                <i className="bi bi-whatsapp fs-1"></i>
              </a>
            </div>
            <div
              className="p-1 d-flex align-items-center justify-content-center rounded-circle me-auto ms-3"
              style={{ width: 75, height: 75, backgroundColor: "#0084ff" }}
            >
              <a href="#" className="text-white">
                <i className="bi bi-messenger fs-1"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default ContactUs;
